// ============================================================================
// CHINESE TRANSLATIONS - UI (中文)
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'zh',
    languageName: '中文',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST 爱的\n编年史",
    subtitle: "互动圣经探索",
    tagline: "走向神圣之光",
    menu: "菜单",
    retry: "重试"
  },
  
  buttons: {
    play: "开始游戏",
    back: "返回",
    continue: "继续",
    restart: "重新开始",
    close: "关闭",
    nextLevel: "下一关",
    selectLevel: "选择关卡",
    retry: "重试",
    mainMenu: "主菜单",
    start: "开始",
    cancel: "取消",
    confirm: "确认",
    save: "保存",
    load: "加载",
    yesRestart: "是的，重新开始",
    noContinue: "不，继续",
    tryAgain: "再试一次",
    backToMenu: "返回菜单"
  },
  
  labels: {
    score: "分数",
    stars: "星星",
    wisdom: "智慧",
    revelation: "启示",
    lives: "生命",
    combo: "连击",
    level: "关卡",
    easy: "简单",
    medium: "中等",
    hard: "困难",
    correct: "正确！",
    gameOver: "试炼失败",
    victory: "胜利！",
    completed: "已完成",
    rank: "灵性等级",
    points: "智慧点数",
    unlockedLevels: "已解锁关卡",
    questionOfKnowledge: "知识问题",
    hintOfWisdom: "智慧提示",
    knowledgeMastered: "知识已掌握！",
    knowledgeAcquired: "知识已获得！",
    testFailed: "试炼失败",
    wisdomBonus: "奖励",
    xpGained: "经验值",
    newRank: "新等级",
    nextGrade: "下一级",
    maxLevelReached: "已达到最高等级！",
    wrongAnswer: "答错了！"
  },
  
  menu: {
    playButton: "开始游戏",
    info: "信息",
    treasures: "宝藏",
    john: "约翰",
    reset: "重置",
    resetConfirm: "重新开始冒险？",
    resetWarning: "您确定要清除所有进度吗？",
    resetLose: "您将失去：",
    wisdomPoints: "智慧点数",
    starsCollected: "收集的星星",
    levelsUnlocked: "解锁的关卡",
    spiritualRank: "灵性等级",
    yesRestart: "是的，重新开始",
    noContinue: "不，继续",
    newAdventure: "新冒险",
    readyToStart: "准备好开始了吗？",
    startJourney: "开始您的圣经知识之旅！",
    audioControls: "音频控制",
    mute: "静音",
    unmute: "取消静音",
    close: "关闭",
    language: "语言",
    restartGame: "重启游戏"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "互动圣经冒险",
    anonymousMode: "匿名游戏",
    anonymousDesc: "选择昵称",
    emailMode: "电子邮件登录",
    emailDesc: "多设备保存",
    pseudo: "昵称",
    pseudoPlaceholder: "您的昵称...",
    email: "电子邮件地址",
    emailPlaceholder: "your@email.com",
    startPlaying: "开始游戏",
    sendLink: "发送链接",
    sending: "发送中...",
    connecting: "连接中...",
    back: "返回",
    localSave: "您的进度将在本地保存",
    cloudSync: "无需密码 • 云同步",
    magicLink: "通过电子邮件接收魔法链接",
    checkEmail: "✉️ 检查您的电子邮件！登录链接已发送。",
    checkSpam: "也请检查您的垃圾邮件文件夹",
    waitingConnection: "等待连接...",
    errorSend: "发送链接错误",
    rateLimited: "⏳ 请等待15秒后再重新发送邮件",
    importSession: "🔄 从生产环境导入会话",
    errorConnection: "连接错误",
    enterPseudo: "请输入昵称",
    enterEmail: "请输入有效的电子邮件",
    // Tooltips
    never: "从未",
    save: "保存游戏",
    lastSave: "最后",
    refresh: "重新加载进度",
    logout: "登出",
    connectToCloud: "连接以在线保存",
    editPseudo: "编辑用户名",
    confirm: "确认",
    cancel: "取消",
    close: "关闭",
    passwordMode: "简单登录",
    passwordDesc: "邮箱 + 密码",
    password: "密码",
    passwordPlaceholder: "至少6个字符",
    passwordMinLength: "至少6个字符",
    playWithoutAccount: "无需帐户即可玩",
    forgotPassword: "忘记密码？",
    resetPasswordTitle: "重置密码",
    resetPasswordSubtitle: "输入您的电子邮件以接收重置链接",
    sendResetLink: "发送链接",
    resetEmailSent: "📧 重置邮件已发送！请检查您的收件箱。",
    errorReset: "发送邮件时出错",
    backToSignin: "返回登录",
    newPassword: "新密码",
    enterNewPassword: "选择一个新的安全密码",
    confirmPassword: "确认密码",
    updatePassword: "更新密码",
    passwordsDontMatch: "密码不匹配",
    passwordUpdateSuccess: "✅ 密码更新成功！",
    errorUpdatePassword: "更新密码时出错",
    resetLinkExpired: "重置链接已过期或无效",
    forgotPassword: "忘记密码？",
    signup: "注册",
    signin: "登录",
    createAccount: "创建账户",
    signupInfo: "填写下面的表格",
    passwordInfo: "使用密码快速访问",
    signupButton: "创建我的账户",
    signinButton: "登录",
    passwordTooShort: "密码必须至少6个字符",
    emailAlreadyExists: "此邮箱已被使用",
    emailExistsHint: "✉️ 此邮箱已注册。请尝试登录！（可能是从另一个游戏创建的？）",
    switchToSignin: "🔑 切换到使用现有邮箱的登录模式",
    invalidCredentials: "邮箱或密码无效",
    signupSuccess: "📧 账户已创建！请查看您的邮箱以确认注册。",
    emailConfirmationRequired: "请查看您的收件箱以激活账户",
    checkSpamFolder: "请记得检查垃圾邮件文件夹",
    connectionSuccess: "✅ 登录成功！",
    errorSignup: "注册时出错"},
  
  install: {
    title: "安装应用",
    subtitle: "快速访问和离线",
    feature1: "从主屏幕即时启动",
    feature2: "安装后可离线工作",
    feature3: "原生应用体验",
    feature4: "无需应用商店下载",
    install: "安装",
    dismiss: "稍后",
    info: "您可以随时卸载应用"
  },
  
  ranks: {
    seeker: "寻求者",
    believer: "觉醒者",
    disciple: "门徒",
    servant: "仆人",
    witness: "见证人",
    guardian: "守护者",
    wise: "智者",
    prophet: "先知",
    apostle: "使徒",
    seekerDesc: "属灵旅程的开始",
    believerDesc: "灵性意识觉醒",
    discipleDesc: "学习教导",
    servantDesc: "服务与奉献",
    witnessDesc: "分享信仰",
    guardianDesc: "保护真理",
    wiseDesc: "智慧与知识",
    prophetDesc: "属灵异象",
    apostleDesc: "属灵大师"
  },

  spiritualJourney: {
    beginning: "属灵旅程的开始",
    progress: "属灵进步",
    grade: "等级",
    xp: "经验值",
    level: "级别",
    nextGrade: "下一等级",
    still: "还需",
    maxLevelReached: "已达到最高级别！",
    masteredAllTeachings: "您已掌握所有教导",
    progression: "进度"
  },
  
  treasures: {
    title: "💎 圣经宝藏",
    verse: "每日经文",
    fact: "你知道吗？",
    treasure: "隐藏宝藏",
    question: "有趣问题",
    context: "背景",
    strongReference: "深入学习的圣经参考",
    verseOfDay: "✨ 每日经文",
    didYouKnow: "🌟 你知道吗？",
    hiddenTreasure: "📜 隐藏宝藏",
    funnyQuestion: "🤔 有趣问题",
    emmanuelMemo: "以马内利的备忘录",
    emmanuelMessage: "您已到达山顶，知识已获得。但坚定不移的信仰需要生活经验、怜悯和对耶稣的真爱。生活中的各种考验将考验您的道路，我们选择的真正道路，我们的心。我们仍然不完美，我们的欲望众多，对利益或个人舒适的热爱往往成为我们自私的优先事项。向上帝祈求智慧、他的爱、他的力量，并谦卑地承认您的弱点，因为没有什么可以对他隐瞒...没有什么。无需在私密模式下旅行、使用VPN或甚至删除历史记录。像但以理一样禁食：暂时剥夺您最爱的东西，在平静和智慧中。这将使您更好地听到上帝，拥有准备好进行深刻 - 而且往往是痛苦的 - 转变的心灵倾向。然后梦想和异象将变得更加清晰，就像约瑟一样。但要警惕骄傲：不要屈服于'我总是对的'或'我知道得更好'。因为上帝的启示是一种非凡的恩典。不要成为律法师，能够在今天再次钉死耶稣，他只是要求爱你的邻居...并给予他们你所获得的同样自由。拥有信仰意味着进入自由的关系和心灵之旅。它将使您成为强大的英雄，能够做到不可能的事情。因为超自然的经历，上帝的存在，他的确认或祝福将使您真正坚定不移。",
    jesusIsNot: "❌ 重要说明",
    clarification: "重要说明",
    bibleOffline: "离线阅读圣经",
    bibleStudy: "圣经学习",
    version: "版本",
    openReader: "打开阅读器",
    features: "功能"
  },
  
  messages: {
    chooseCard: "⚡ 选择您的能力卡",
    cardHelp: "它将陪伴您完成本关的3个问题",
    chooseAnswer: "📖 选择您的答案：",
    wrongAnswer: "❌ 答错了！您还有 {lives} 条生命。再试一次！",
    levelCompleted: "关卡 {level} 完成",
    questionsProgress: "问题 {current}/3",
    starsCollected: "收集的星星：{current}/{total}",
    pointsEarned: "+{points} 智慧点数",
    defeatedQuote: "我靠着那加给我力量的，凡事都能做",
    chapter: "章节",
    chapterStars: "章节星星",
    totalGlobal: "总计",
    backToMenu: "返回菜单"
  },
  
  quotes: {
    wisdom: "敬畏耶和华是智慧的开端",
    faith: "我靠着那加给我力量的，凡事都能做",
    hope: "耶和华是我的牧者，我必不至缺乏",
    love: "神爱世人，甚至将他的独生子赐给他们...",
    perseverance: "信仰需要坚持",
    defeat: "失败邀请在知识中成长"
  },

  cards: {
    faith: "信仰",
    courage: "勇气",
    wisdom: "智慧",
    faithKnowledge: "+50% 分数",
    courageKnowledge: "第二次机会",
    wisdomKnowledge: "提示 + 奖励",
    faithDesc: "获得的最大智慧分数",
    courageDesc: "正常分数但有第二次机会",
    wisdomDesc: "揭示的提示和 +25% 分数",
    chooseCard: "✨ 选择一个知识恩赐",
    cardEffects: "✨ 知识恩赐的效果：",
    faithEffect: "+50% 智慧分数 - 最大奖励",
    courageEffect: "正常分数但错误时有第二次机会",
    wisdomEffect: "+25% 分数 + 每个问题都揭示提示",
    chooseWisely: "明智地选择，因为您的选择将伴随您整个关卡"
  },

  challenge: {
    loading: "正在加载关卡...",
    peace: "🕊️ 愿平安降临你的家",
    questionsAwaiting: "🎯 3个知识问题等待着你",
    starsQuote: "每颗星星都是通向神圣之光的一步"
  },

  chapters: {
    "1": "创世记",
    "2": "出埃及记",
    "3": "耶稣基督",
    "4": "钉十字架/复活",
    "5": "早期教会",
    "6": "保罗的宣教",
    "7": "书信/启示录",
    "8": "奖励关卡"
  },

  bible: {
    readerTitle: "📖 圣经阅读器",
    loading: "正在加载圣经...",
    menu: "菜单",
    strong: "Strong",
    strongReferences: "Strong参考",
    verses: "节",
    previous: "上一个",
    next: "下一个",
    strongDefinition: "Strong参考",
    word: "原文",
    transliteration: "音译",
    pronunciation: "发音",
    meaning: "含义",
    definition: "完整定义",
    usage: "圣经用法",
    etymology: "词源",
    close: "关闭",
    moreReferences: "和{{count}}个其他参考",
    copyright: "📖 Chinese Union Version - 公共领域 • 包含Strong编号"
  },

  philosophy: {
    title: "哲学维度",
    loveOntology: "爱作为本体论原则",
    loveDescription: "耶稣将爱转化为形而上学的基础：爱神和爱人成为真实存在的结构本身。爱超越道德，成为存在的方式。",
    newCommandment: "新命令",
    jesusEmphasizes: "当耶稣给出新命令时，他强调爱这个动词",
    loveGod: "全心全意爱神",
    loveNeighbor: "爱人如己",
    lovePriority: "爱成为优先事项"
  },

  footer: {
    version: "版本 1.0 • 2024",
    dedication: "为神的荣耀而开发"
  },

  endCredits: {
    lines: [
      { text: "你已经到达山顶", delay: 2000 },
      { text: "你学到了很多东西", delay: 2000 },
      { text: "你的信仰每天都在增长", delay: 2000 },
      { text: "你与神一起经历美好的事物", delay: 2000 },
      { text: "困难帮助你成长", delay: 2000 },
      { text: "它们显示什么是重要的", delay: 2000 },
      { text: "像小孩子一样谦卑", delay: 2000 },
      { text: "神爱你单纯的心", delay: 2000 },
      { text: "在宁静中你听到神", delay: 2000 },
      { text: "禁食释放你的灵魂", delay: 2000 },
      { text: "祷告，神会引导你", delay: 2000 },
      { text: "骄傲掩盖真理", delay: 2000 },
      { text: "神的恩典是壮丽的", delay: 2000 },
      { text: "它来自神的心", delay: 2000 },
      { text: "真正的信仰使你自由", delay: 2000 },
      { text: "它将你与神永远联合", delay: 2000 },
      { text: "爱可以改变一切", delay: 2000 },
      { text: "它可以创造奇迹", delay: 2000 },
      { text: "跟我重复", delay: 2000 },
      { text: "耶稣，我把我的心献给你", delay: 3000 },
      { text: "你是我的王，我的救主", delay: 3000 },
      { text: "来改变我的生命", delay: 3000 },
      { text: "旅程现在继续", delay: 2000 },
      { text: "分享这美丽的光", delay: 2000 },
      { text: "走向永不结束的生命", delay: 2000 },
      { text: "将爱保存在你的心中", delay: 3000 },
      { text: "像珍贵的宝藏", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "恭喜！",
      proud: "我们为你骄傲",
      courage: "勇敢的战士",
      peace: "和平使者",
      child: "神的孩子",
      blessing: "愿神祝福你",
      continue: "继续"
    }
  },

  mountain: {
    spiritualAscension: "灵性提升",
    levelProgress: "等级 {{level}} • 获得 {{stars}} 颗星",
    combo: "连击",
    perfectMessage: "\"因为我的意念非同你们的意念\" - 羔羊攀登至完美智慧",
    goodMessage: "\"寻找就寻见\" - 继续向真理攀升",
    startMessage: "\"信心虽小如芥菜种\" - 迈向光明的第一步",
    skipAnimation: "跳过动画",
    chapter: "章节",
    chapterProgress: "章节 {{current}}/{{total}}",
    secret: "秘密",
    waypoints: {
      start: "开始",
      firstSlope: "第一个斜坡",
      lastSlope: "最后一个斜坡"
    },
    status: {
      defeat: "失败",
      inProgress: "进行中",
      victory: "胜利"
    }
  },

  validation: {
    pseudoTooShort: "用户名必须至少包含2个字符",
    enterPseudo: "请输入用户名"
  },

  pseudoSetup: {
    title: "选择您的用户名",
    confirm: "确认名称"
  },

  navigation: {
    back: "返回"
  },

  console: {
    starsUnlocked: "星星达成！解锁章节",
    defeatAnimation: "失败...耶稣基督下降"
  },

  errors: {
    progressionError: "进度错误",
    invalidProgressionData: "无效的进度数据："
  },

  levels: {
    chaptersAndBonus: "8章 + 奖励关卡",
    bonusUnlocked: "🏆 奖励关卡解锁！您已达到精神完美！",
    starsToDiscover: "273 {stars} 待发现",
    starsPerLevel: "每关 3 {stars}"
  },

  architecture: {
    title: "🔧 技术架构",
    react: {
      name: "React",
      description: "现代界面"
    },
    modules: {
      name: "模块",
      description: "动态加载"
    },
    localStorage: {
      name: "本地存储",
      description: "本地存储"
    },
    tailwind: {
      name: "Tailwind",
      description: "响应式设计"
    }
  },

  info: {
    title: "Unity Quest 和平编年史",
    subtitle: "互动圣经探索",
    yourStats: "您的统计",
    score: "分数",
    wisdom: "智慧",
    revelation: "启示",
    createdWith: "用 ❤️ 创建",
    creator: "Emmanuel Payet",
    developerPassionate: "热爱灵性的开发者",
    artistModule: "Emmanuel 艺术家",
    artistPortfolio: "艺术作品集和数字创作",
    features: "特色",
    multipleChapters: "91个关卡分布在8个圣经章节中",
    powerCards: "3张独特的力量卡（信心、勇气、智慧）",
    progressionSystem: "具有灵性等级的进度系统",
    bibleTreasures: "圣经宝藏和有趣的事实",
    howToPlay: "如何游戏",
    selectLevel: "选择已解锁的关卡",
    choosePowerCard: "选择你的力量卡",
    answerQuestions: "回答3个知识问题",
    earnStars: "根据剩余生命获得星星",
    tips: "提示",
    readCarefully: "仔细阅读每个问题",
    useWisdomCard: "使用智慧卡获得提示",
    courageGivesSecondChance: "勇气卡给你第二次机会",
    faithMaximizes: "信心卡最大化你的分数",
    johnGospelTitle: "约翰福音",
    johnGospelStats: "21章 • 878节 • 14种语言",
    bibleReaderStrong: "圣经阅读器 + Strong",
    bibleReaderStrongDesc: "完整阅读与Strong词典",
    johnTreasures: "约翰的宝藏",
    johnTreasuresDesc: "圣经宝藏和有趣的事实",
    quickAccessChapters: "快速访问著名章节：",
    johnChapter1: "序言",
    johnChapter3: "重生",
    johnChapter14: "我是道路",
    johnChapter20: "复活",
    version: "版本",
    madeWithLove: "为荣耀上帝而制作",
    backToMenu: "返回菜单"
  },

  bible: {
    readerTitle: "📖 圣经阅读器",
    johnReaderTitle: "圣经阅读器 - 约翰福音",
    john: "约翰",
    loading: "正在加载圣经...",
    loadingChapter: "约翰福音第 {chapter} 章。完整数据正在加载中...",
    exploreWhileLoading: "同时，您可以探索其他章节或使用搜索功能。",
    menu: "菜单",
    tabBible: "圣经",
    tabUnity: "合一",
    strong: "Strong",
    strongReferences: "Strong参考",
    verses: "节",
    previous: "上一个",
    next: "下一个",
    strongDefinition: "Strong参考",
    word: "原文单词",
    transliteration: "音译",
    close: "关闭",
    share: "分享",
    shareVerse: "分享此节",
    shareSelection: "分享选择",
    pronunciation: "发音",
    meaning: "含义",
    definition: "完整定义",
    usage: "圣经用法",
    etymology: "词源",
    search: "搜索...",
    definitionNotFound: "未找到定义",
    definitionLoading: "定义加载中...",
    imageFeatureComing: "🖼️ 图像功能即将推出！",
    copyError: "复制错误：",
    error: "❌ 错误",
    errorLoading: "加载错误",
    retry: "重试",
    readerInDevelopment: "约翰福音阅读器开发中...",
    verseCopied: "经文已复制到剪贴板！",
    moreReferences: "和 {{count}} 个其他参考",
    copyright: "📖 LSG 1910 • 包含Strong",
    markAsRead: "段落已读",
    alreadyRead: "已阅读",
    readingBonus: "阅读奖励",
    results: "结果",
    result: "结果",
    copy: "复制",
    image: "图片"
  },

  mountain: {
    chapter: "章节",
    secret: "秘密！",
    spiritualAscension: "灵性提升",
    levelProgress: "关卡 {{level}} • 获得 {{stars}} 颗星",
    combo: "连击",
    perfectMessage: '"因为我的意念非同你们的意念" - 羔羊向完美智慧攀登',
    goodMessage: '"寻找就寻见" - 向真理的攀登继续',
    startMessage: '"信心，即使小如芥菜种" - 迈向光明的第一步',
    skipAnimation: "跳过动画",
    stats: {
      points: "分",
      level: "级"
    },
    waypoints: {
      start: "起点",
      firstSlope: "第一个坡",
      lastSlope: "最后一个坡"
    },
    status: {
      victory: "胜利！",
      defeat: "失败",
      inProgress: "进行中"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "在应用中阅读",
      description: "内置Strong圣经阅读器",
      features: {
        offline: "离线",
        strong: "Strong编号",
        navigation: "导航"
      }
    }
  },

  quotes: {
    wisdom: "真正的知识通向永恒的智慧",
    faith: "靠着那加给我力量的，凡事都能做",
    hope: "耶和华是我的牧者，我必不至缺乏",
    love: "神爱世人...",
    perseverance: "信心需要坚持",
    defeat: "失败邀请在知识中成长"
  },

  philosophy: {
    title: "哲学维度",
    loveOntology: "爱作为本体论原则",
    loveDescription: "耶稣将爱转化为形而上学的基础：爱上帝和邻舍成为真实存在的结构本身。爱超越道德成为存在的方式。",
    newCommandment: "新命令",
    jesusEmphasizes: "当耶稣给出新命令时，他强调爱的动词",
    loveGod: "尽心爱上帝",
    loveNeighbor: "爱邻舍如同自己",
    lovePriority: "爱成为优先事项"
  },

  unity: unityTranslations,

  footer: {
    version: "版本 1.0 • 2024",
    dedication: "为荣耀上帝而开发"
  },

  endCredits: {
    lines: [
      { text: "你已到达山顶", delay: 2000 },
      { text: "你学到了很多东西", delay: 2000 },
      { text: "你的信心每天都在增长", delay: 2000 },
      { text: "你与上帝一起经历美好", delay: 2000 },
      { text: "困难帮助你成长", delay: 2000 },
      { text: "它们显示什么是重要的", delay: 2000 },
      { text: "像孩子一样谦卑", delay: 2000 },
      { text: "上帝爱你单纯的心", delay: 2000 },
      { text: "在安静中你听到上帝", delay: 2000 },
      { text: "禁食释放你的灵", delay: 2000 },
      { text: "祈祷，上帝会引导你", delay: 2000 },
      { text: "骄傲隐藏真理", delay: 2000 },
      { text: "上帝的恩典是宏伟的", delay: 2000 },
      { text: "它来自上帝的心", delay: 2000 },
      { text: "真正的信心使你自由", delay: 2000 },
      { text: "它将你与上帝永远联合", delay: 2000 },
      { text: "爱可以改变一切", delay: 2000 },
      { text: "它可以创造奇迹", delay: 2000 },
      { text: "跟我一起说", delay: 2000 },
      { text: "耶稣，我把我的心给你", delay: 3000 },
      { text: "你是我的王，我的救主", delay: 3000 },
      { text: "来改变我的生命", delay: 3000 },
      { text: "道路现在继续", delay: 2000 },
      { text: "分享这美好的光", delay: 2000 },
      { text: "通向永不结束的生命", delay: 2000 },
      { text: "将爱保存在你心中", delay: 3000 },
      { text: "像珍贵的宝藏", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "恭喜！",
      proud: "我们为你骄傲",
      courage: "勇敢的勇气",
      peace: "和平使者",
      child: "上帝的孩子",
      blessing: "愿上帝祝福你",
      continue: "继续"
    }
  },

  validation: {
    pseudoTooShort: "昵称必须至少包含2个字符",
    enterPseudo: "请输入昵称"
  },

  pseudoSetup: {
    title: "选择你的游戏昵称",
    profileConfig: "个人资料配置",
    connectedWith: "连接方式",
    playerPseudo: "游戏昵称",
    pseudoPlaceholder: "你的昵称...",
    pseudoRequirements: "2-20个字符 • 显示在排行榜中",
    suggestions: "建议",
    confirm: "确认昵称",
    errorConfig: "配置错误"
  },

  navigation: {
    back: "返回"
  },

  console: {
    starsUnlocked: "星星达成！章节解锁",
    defeatAnimation: "失败... 耶稣下降"
  },

  errors: {
    progressionError: "进度错误",
    invalidProgressionData: "无效的进度数据："
  },

  levels: {
    chaptersAndBonus: "8章 + 奖励关卡",
    bonusUnlocked: "🎊 奖励关卡已解锁！你达到了灵性完美！",
    starsToDiscover: "273 {stars} 等待发现",
    starsPerLevel: "每关 3 {stars}"
  },

  architecture: {
    title: "🏗️ 技术架构",
    react: {
      name: "React",
      description: "现代界面"
    },
    modules: {
      name: "模块",
      description: "动态加载"
    },
    localStorage: {
      name: "LocalStorage",
      description: "本地保存"
    },
    tailwind: {
      name: "Tailwind",
      description: "响应式设计"
    }
  },

  gameManager: {
    title: "游戏保存",
    saveLocal: "本地保存",
    saveCloud: "云同步",
    saveWaiting: "等待连接",
    lastSave: "上次保存：",
    never: "从未",
    saving: "保存中...",
    save: "保存",
    loadProgress: "加载",
    loading: "加载中...",
    autoSaveEnabled: "💾 自动保存已启用",
    saveError: "❌ 保存错误",
    gameSaved: "✅ 游戏已保存！",
    gameLoaded: "📥 游戏已加载！"
  }
};

export default uiTranslations;
